import { render, staticRenderFns } from "./idolDrinkPackageOrderList.vue?vue&type=template&id=ab814206&scoped=true"
import script from "./idolDrinkPackageOrderList.vue?vue&type=script&lang=ts"
export * from "./idolDrinkPackageOrderList.vue?vue&type=script&lang=ts"
import style0 from "./idolDrinkPackageOrderList.vue?vue&type=style&index=0&id=ab814206&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab814206",
  null
  
)

export default component.exports